import { Injectable } from '@angular/core'
import { UploadVersionType } from '@app/recorder-module/core/types/upload'
import { BehaviorSubject, Subject } from 'rxjs'

export interface IVideoTranscodingSocketMeta {
  upload_uuid: string
  big_preview_url: string
  small_preview_url: string
  progress: number
  state: string
  type: UploadVersionType
}

export interface IVideoTranscodingServiceData {
  [key: string]: IVideoTranscodingSocketMeta
}

@Injectable({
  providedIn: 'root',
})
export class VideoTranscodingService {
  data: IVideoTranscodingServiceData = {}
  dataSubject = new Subject<IVideoTranscodingServiceData>()
  data$ = this.dataSubject.asObservable()

  constructor() {}

  update(value: IVideoTranscodingSocketMeta) {
    this.data[value.upload_uuid] = value
    this.dataSubject.next(this.data)
    if (value.progress === 100) {
      delete this.data[value.upload_uuid]
    }
  }

  destroy(): void {
    this.dataSubject.complete()
  }
}
